<template>
  <div class="py-3">
    <div
      v-if="$login.can('subscriptions.update')"
      class="pb-4 mb-3 add-user-wrapper form-group border-bottom"
    >
      <label>
        Add Users
      </label>

      <div class="">
        <quick-selector
          ref="users"
          v-model="addUser"
          :options="searchedUsers"
          :selected="[]"
          :allow-creation="true"
          :async="true"
          class="mt-1"
          placeholder="Start typing to find an user..."
          @search-changed="delayGetUsers"
          @create="$router.replace({
            name: 'users.create',
            query: {
              onComplete: $route.path
            }
          })"
        >
          <span
            slot="option"
            slot-scope="prop"
          >
            {{ prop.option.name }} <span v-if="prop.option.email">
              ({{ prop.option.email }})
            </span>
          </span>
          <span
            slot="create-option"
            slot-scope="prop"
          >
            Create {{ prop.option.name }}
          </span>
        </quick-selector>
      </div>
    </div>

    <div class="mt-3">
      <div class="mb-3 form-group">
        <label for="">
          Attached Users
        </label>
        <search v-model="params.search" />
      </div>

      <users-table :users="users">
        <template
          slot="options"
          slot-scope="scope"
        >
          <dropdown-option
            v-if="$login.can('subscriptions.update') && (!data.is_all_users || scope.user.account_id != data.account_id)"
            class="page-header-dropdown-item"
            @click.native="deleteUser = scope.user"
          >
            <icon icon="cross-badge" />
            Remove from subscription
          </dropdown-option>
        </template>
      </users-table>

      <pagination
        :data="pagination"
        :disabled="loading"
        @change-page="changePage"
      />
    </div>

    <confirm
      v-if="deleteUser"
      :name="deleteUser.name"
      modal="confirm-delete-user"
      @confirmed="deleteSelectedUser"
    />
  </div>
</template>

<script>
import Confirm from '@/components/Confirm'
import {debounce} from '@/helpers'
import {search} from '@/helpers'
import UsersTable from '@/views/users/Table'
import Search from '@/components/Search'
import Pagination from '@/components/Pagination'
import QuickSelector from '@/components/QuickSelector'
import {successNotification, errorNotification} from '@/notifications'
import DropdownOption from '@/components/Dropdown/DropdownOption'

const defaultPagination = () => {
  return {
    page: 1,
    search: null,
  }
}

export default {
  components: {
    Confirm,
    UsersTable,
    Search,
    QuickSelector,
    DropdownOption,
    Pagination,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      loading: false,
      error: null,
      dates: null,
      addUser: [],
      deleteUser: null,
      searchedUsers: [],
      users: [],
      pagination: null,
      params: defaultPagination(),
    }
  },

  watch: {
    addUser () {
      if (this.addUser.length > 0) {
        const user = this.addUser[0]

        this.$http
            .post(`/subscriptions/${this.data.id}/users`, {
              user_id: user.id,
            })
            .then(this.addSuccessfully)
            .catch(this.addFail)
      }
    },

    deleteUser () {
      if (this.deleteUser) {
        this.$nextTick(() => this.$modal.show('confirm-delete-user'))
      }
    },

    'params': {
      deep: true,
      handler () {
        this.getUsers()
      },
    },

    'data.id' () {
      this.getUsers()
    },
  },

  mounted () {
    this.getUsers()
  },

  methods: {
    getUsers () {
      const params = this.params

      this.$http
          .get(`/subscriptions/${this.data.id}/users`, {
            params,
          })
          .then((response) => {
            this.users = response.data.data
            this.pagination = response.data.meta
          })
    },

    deleteSelectedUser () {
      const params = {
        user_id: this.deleteUser.id,
      }

      this.$http
          .delete(
              `/subscriptions/${this.$route.params.subscriptionId}/users`,
              {
                params,
              }
          )
          .then(this.deleteUserSuccessfully)
          .catch(this.deleteUserFail)
    },

    deleteUserSuccessfully () {
      const user = this.deleteUser

      this.users.splice(this.users.indexOf(user), 1)
      this.deleteUser = null
      this.$notify(successNotification(`Removed ${user.name} from ${this.data.name}`))
    },

    deleteUserFail () {
      const user = this.deleteUser
      this.addUser = []
      this.$notify(errorNotification(`Unable to remove ${user.name} from ${this.data.name}`))
    },

    addSuccessfully () {
      const user = this.addUser[0]

      this.users.unshift(user)
      this.addUser = []
      this.$notify(successNotification(`Added ${user.name} to ${this.data.name}`))
    },

    addFail () {
      const user = this.addUser[0]
      this.addUser = []
      this.$notify(errorNotification(`Unable to add ${user.name} to ${this.data.name}`))
    },

    setData (erer, subscription) {
      this.data = subscription.data
    },

    delayGetUsers: debounce(function (query) {
      search('users', query).then((response) => {
        this.searchedUsers = response.data
      })
    }, 200),

    changePage (page) {
      this.params.page = page
    },
  },
}
</script>
